import React, { useMemo } from 'react';
import { Box, Button, IconButton, MenuItem, Typography } from '@mui/material';
import { Edit, Delete, Print } from '@mui/icons-material';
import { MaterialReactTable } from 'material-react-table';
import DataList from '../../../form/DataList';
import Input from '../../../form/Input';
import { useMRTState } from '../../../../hooks/useMRTState';
import { getMRTDefaultProps } from '../../../../helpers/mrt/getMRTDefaultProps';

export default function ComissaoTab({ membros, modulo, ocupado, bloqueado, parametro, isMobile }) {
    const mrt = useMRTState({ storageKey: 'Eleicao.Comissao', pageSizeDefault: Number(parametro?.paginacao) || 5 });
    const defaults = getMRTDefaultProps({ mrt, parametro, isMobile });
    const columns = useMemo(
        () => [
            {
                id: 'comissao',
                header: 'Cadastro da comissão eleitoral',
                columns: [
                    { accessorKey: 'ordem', header: 'Ordem', size: 70 },
                    { accessorKey: 'Pessoa.descricao', header: 'Pessoa' },
                    { accessorKey: 'rhCargo.descricao', header: 'Cargo' },
                ],
            },
        ],
        []
    );

    return (
        <Box sx={{ py: 2, minWidth: 0 }}>
            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 2,
                    alignItems: 'flex-end',
                    mb: 2,
                    '& > .eleicao-campo > *': { margin: 0 },
                    '& > .eleicao-campo input': { boxSizing: 'border-box', height: '34px', marginBottom: 0 },
                }}
            >
                <Box className="eleicao-campo" sx={{ width: { xs: '100%', sm: 360 } }}>
                    <DataList
                        inputWidth="100%"
                        text="Pessoa"
                        name="pessoa"
                        value={modulo.item.pessoa}
                        filteredOptions={modulo.pessoas}
                        handleOnChange={modulo.alterar}
                        readonly={bloqueado}
                        placeholder="Digite pelo menos 2 caracteres"
                    />
                </Box>
                <Box className="eleicao-campo" sx={{ width: { xs: '100%', sm: 260 } }}>
                    <DataList
                        inputWidth="100%"
                        text="Cargo da comissão"
                        name="cargo"
                        value={modulo.item.cargo}
                        filteredOptions={modulo.cargos}
                        handleOnChange={modulo.alterar}
                        readonly={bloqueado}
                        placeholder="Digite pelo menos 2 caracteres"
                    />
                </Box>
                <Box className="eleicao-campo" sx={{ width: 100 }}>
                    <Input
                        inputWidth="100%"
                        text="Ordem"
                        type="number"
                        name="ordem"
                        value={modulo.item.ordem}
                        handleOnChange={modulo.alterar}
                        readonly={bloqueado}
                    />
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        gap: 1,
                        alignItems: 'center',
                        '& .MuiButton-root': { height: '34px', minHeight: '34px', py: 0 },
                    }}
                >
                    <Button type="button" variant="contained" onClick={modulo.adicionar} disabled={bloqueado}>
                        {modulo.editando ? 'Atualizar membro' : 'Adicionar membro'}
                    </Button>
                    <Button type="button" onClick={modulo.limpar} disabled={bloqueado}>
                        Limpar
                    </Button>
                </Box>
            </Box>
            <Button
                type="button"
                variant="outlined"
                startIcon={<Print />}
                sx={{ mb: 2 }}
                disabled={ocupado || !modulo.podeImprimir}
                onClick={modulo.imprimirQualificacao}
                title="Imprimir a qualificação dos membros salvos da comissão eleitoral"
            >
                {modulo.imprimindo ? 'Gerando PDF...' : 'Imprimir qualificação'}
            </Button>
            <Typography variant="body2" sx={{ mb: 1 }}>
                As alterações da comissão serão gravadas ao salvar a eleição.
            </Typography>
            <MaterialReactTable
                {...defaults}
                columns={columns}
                data={membros}
                getRowId={(row) => String(row.pessoaId)}
                manualFiltering={false}
                manualSorting={false}
                manualPagination={false}
                rowCount={undefined}
                enableRowSelection={false}
                autoResetPageIndex={true}
                renderRowActions={
                    isMobile
                        ? undefined
                        : ({ row }) => (
                              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                  <IconButton
                                      type="button"
                                      title="Editar membro"
                                      disabled={bloqueado}
                                      onClick={() => modulo.editar(row.original)}
                                  >
                                      <Edit />
                                  </IconButton>
                                  <IconButton
                                      type="button"
                                      title="Remover membro"
                                      color="error"
                                      disabled={bloqueado}
                                      onClick={() => modulo.remover(row.original)}
                                  >
                                      <Delete />
                                  </IconButton>
                              </Box>
                          )
                }
                renderRowActionMenuItems={
                    isMobile
                        ? ({ row, closeMenu }) => [
                              <MenuItem
                                  key="editar"
                                  disabled={bloqueado}
                                  onClick={() => {
                                      closeMenu();
                                      modulo.editar(row.original);
                                  }}
                              >
                                  Editar
                              </MenuItem>,
                              <MenuItem
                                  key="remover"
                                  disabled={bloqueado}
                                  onClick={() => {
                                      closeMenu();
                                      modulo.remover(row.original);
                                  }}
                              >
                                  Remover
                              </MenuItem>,
                          ]
                        : undefined
                }
            />
        </Box>
    );
}
